import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  Textarea,
  useColorModeValue,
  Image,
  Input,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import { MdUpload } from "react-icons/md";
import useProfileService from "services/profileService"; 

export default function Upload(props) {
  const { used, total, ...rest } = props;
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [description, setDescription] = useState("");
  const { postSupportRequest } = useProfileService();
  const fileInputRef = useRef(null);

  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    console.log("File selected:", selectedFile);
    
    if (selectedFile) {
      setFile(selectedFile);
      const fileUrl = URL.createObjectURL(selectedFile);
      setPreviewUrl(fileUrl);
      console.log("Preview URL created:", fileUrl);
    } else {
      console.log("No file selected");
    }
  };

  const handleSend = async () => {
    if (!file || !description.trim()) {
      console.log("File or description missing");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("description", description);

    try {
      console.log("Sending request with formData:", formData);
      const result = await postSupportRequest(formData);
      console.log("Request result:", result);

      setFile(null);
      setPreviewUrl(null);
      setDescription("");
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };

  return (
    <Card {...rest} mb='0px' align='center' p='20px'>
      <Flex h='100%' direction={{ base: "column", "2xl": "row" }}>
        <Box
          w={{ base: "100%", "2xl": "268px" }}
          me='36px'
          h={{ base: "200px", "2xl": "100%" }}
          border="2px dashed"
          borderColor={brandColor}
          borderRadius="md"
          display="flex"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          overflow="hidden"
          position="relative"
          onClick={() => fileInputRef.current.click()}
        >
          <Input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            ref={fileInputRef}
            display="none"
          />
          {previewUrl ? (
            <Image src={previewUrl} alt="Uploaded" maxH="100%" maxW="100%" objectFit="contain" />
          ) : (
            <Box textAlign="center" zIndex="1">
              <Icon as={MdUpload} w='60px' h='60px' color={brandColor} />
              <Text fontSize='xl' fontWeight='700' color={brandColor}>
                Charger une image
              </Text>
              <Text fontSize='sm' fontWeight='500' color='secondaryGray.500'>
                Format PNG, JPG ou GIF
              </Text>
            </Box>
          )}
        </Box>
        <Flex direction='column' pe='44px' width="100%">
          <Text
            color={textColorPrimary}
            fontWeight='bold'
            textAlign='start'
            fontSize='2xl'
            mt={{ base: "30px", "2xl": "50px" }}>
            Vous avez besoin d'aide ?
          </Text>
          <Text
            color={textColorSecondary}
            fontSize='md'
            my={{ base: "auto", "2xl": "20px" }}
            mx='auto'
            textAlign='start'>
            C'est plus simple avec un screenshot :) <br></br>Envoyez nous une impression d'écran et nous ferons le nécessaire rapidement.
          </Text>
          <Textarea
            placeholder="Décrivez votre problème ici..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            mb="20px"
          />
          <Button
            me='100%'
            mb='40px'
            w='140px'
            minW='140px'
            mt={{ base: "20px", "2xl": "auto" }}
            variant='brand'
            fontWeight='500'
            onClick={handleSend}
            isDisabled={!file || !description.trim()}
          >
            Envoyer
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
}